import { motion } from "framer-motion"
import React from "react"
import * as styles from "./FetchSpinner.module.scss"

const FetchSpinner = (props) => (
  <motion.div
    className={styles.FetchSpinner}
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
  >
    <div className={styles.spinner} />
  </motion.div>
)

export default FetchSpinner
